(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  var badges = document.querySelectorAll('[data-festive-sale-pulse]');
  if (!badges.length) return;

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-visible', entry.isIntersecting);
    });
  }, { threshold: 0.15 });

  badges.forEach(function (badge) {
    observer.observe(badge);
  });
})();
